// Ported verbatim from the mobile app (PrecisionReactNative src/common/assets/images/equipment/eqCablesSVG.tsx); generated — regenerate rather than edit.
import * as React from "react";

type Props = {
  fill: string;
  width?: number;
  height?: number;
};

function EqCablesSvg(props: Props) {
  const {fill, width = 16, height = 16} = props;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M15.5 3C15.5 4.65685 14.1569 6 12.5 6C10.8431 6 9.5 4.65685 9.5 3C9.5 1.34315 10.8431 0 12.5 0C14.1569 0 15.5 1.34315 15.5 3ZM14.7747 7.038L22.7357 9.313L22.1867 11.236L15.4997 9.326V24H13.4997V16H11.4997V19H9.49967V9.326L2.81267 11.236L2.26367 9.313L10.2247 7.038C10.3142 7.01286 10.4067 7.00007 10.4997 7H14.4997C14.5926 7.00007 14.6852 7.01286 14.7747 7.038ZM11.5 21.931C9.5685 21.6859 7.79244 20.7456 6.50406 19.2858C5.21568 17.8261 4.50324 15.947 4.5 14V13H2.5V14C2.50312 16.4781 3.42504 18.8669 5.08745 20.7046C6.74986 22.5423 9.03466 23.6983 11.5 23.949V21.931ZM20.5 14V13H22.5V14C22.4977 15.7531 22.0345 17.4748 21.1569 18.9925C20.2794 20.5101 19.0182 21.7704 17.5 22.647V20.235C18.4357 19.4873 19.1912 18.5387 19.7105 17.4594C20.2298 16.3801 20.4997 15.1977 20.5 14Z"
        fill={fill}
      />
    </svg>
  );
}

export default EqCablesSvg;
